import { ParameterPropertyType } from 'src/types'

import { transformTextParamsData } from '@pages/Parameters/helpers'

export const getColumnParameterStyles = (params?: ParameterPropertyType[]) => {
  if (!params) {
    return {
      styles: {},
      transformedParams: null,
    }
  }

  const transformedParams = transformTextParamsData(params)
  const isBold = transformedParams?.formats.find(format => format === 'bold')

  return {
    styles: {
      fontFamily: transformedParams?.fontFamily.label,
      fontSize: `${transformedParams?.fontSize}px`,
      fontWeight: transformedParams?.formats.find(format => format === 'bold') ? 'bold' : 'normal',
      '--unstable_DataGrid-headWeight': isBold ? 'bold' : 'normal',
      fontStyle: transformedParams?.formats.find(format => format === 'italic')
        ? 'italic'
        : 'normal',
      color: transformedParams?.fontColor,
      background: transformedParams?.bgFontColor ?? 'inherit',
      borderColor: transformedParams?.borderColor ?? 'none',
    },
    transformedParams,
  }
}
